module.exports = __webpack_public_path__ + "img/SECCION-CULTIVOS-MAS-RENTABLES.8f4d9fc3.png";